import { render, staticRenderFns } from "./questionTypeList.vue?vue&type=template&id=b35b83a8&scoped=true&"
import script from "./questionTypeList.vue?vue&type=script&lang=js&"
export * from "./questionTypeList.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeList.vue?vue&type=style&index=0&id=b35b83a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b83a8",
  null
  
)

export default component.exports